import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import Transactions from './components/Transactions';
import Funding from './components/Funding';
import ChargeBacks from './components/Chargebacks';

type Props = {
  location: {
    pathname: string
  },
};

const Reporting = (props: Props) => {
  const [current, setCurrent] = useState('transactions');
  const {
    location,
  } = props;

  const setMenu = (query) => {
    switch (query) {
      case '/transactions/reporting': {
        setCurrent('transactions');
        break;
      }
      case '/funding/reporting': {
        setCurrent('funding');
        break;
      }
      case '/chargebacks/reporting': {
        setCurrent('charge');
        break;
      }
      default:
        setCurrent('transactions');
    }
  };

  useEffect(() => {
    setMenu(location.pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="transactions">
          <SpTab
            to="/transactions/reporting"
            selected={current === 'transactions'}
          >
            TRANSACTIONS
          </SpTab>
        </Menu.Item>
        <Menu.Item key="funding">
          <SpTab
            to="/funding/reporting"
            selected={current === 'funding'}
          >
            FUNDING
          </SpTab>
        </Menu.Item>
        <Menu.Item key="charge">
          <SpTab
            to="/chargebacks/reporting"
            selected={current === 'charge'}
          >
            CHARGEBACKS
          </SpTab>
        </Menu.Item>
      </Menu>
      <Switch>
        <Route exact path="/transactions/reporting" component={Transactions} />
        <Route exact path="/funding/reporting" component={Funding} />
        <Route exact path="/chargebacks/reporting" component={ChargeBacks} />
      </Switch>
    </div>
  );
};

export default withRouter(Reporting);
